import { Button, createStyles, Dialog, WithStyles, withStyles } from '@material-ui/core';
import { AxiosPromise } from 'axios';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { TDispatch } from 'Typings/Global';
import CircularLoader from '../../../Components/Loader/CircularLoader';
import { Book } from '../../../Models/Books/@types';
import BookCard from '../../../Models/Books/BookCard';
import BookDetails from '../../../Models/Books/BookDetails';
import Form from '../../../Models/Books/Form';
import { OBook } from '../../../Models/Books/Model';
import MuiTheme from '../../../MuiTheme';
import { ReduxStore } from '../../../stores';

interface IStateProps {
    mainList?: Array<Book>
}

interface IDispatchProps {
    getPageData: () => AxiosPromise
    deleteBook: (id: string) => AxiosPromise
    togglePublish: (book: Book) => AxiosPromise
}

interface OwnProps { }

interface IProps extends WithStyles<typeof STYLES>, RouteComponentProps, IStateProps, IDispatchProps, OwnProps {

}

interface IState {
    showForm: boolean
    selectedBook?: Book
    showConfirmationDialog: boolean
    bookToDelete?: Book
    bookToEdit?: Book
    loading: boolean
}

class Books extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            showForm: false,
            showConfirmationDialog: false,
            loading: false
        }
    }

    async componentDidMount() {
        this.setState({ loading: true });
        await this.props.getPageData().catch(error => { console.log('Error getting Book Data', error.response) });
        this.setState({ loading: false });
    }

    render() {
        const { classes, mainList = [] } = this.props;
        const { loading, showForm, bookToEdit, selectedBook } = this.state;
        console.log('object', showForm);
        return (
            <>
                {
                    !showForm ?
                        <div className={classes.root} >
                            {
                                loading
                                    ?
                                    <CircularLoader />
                                    :
                                    <div className={classes.listContainer} >
                                        {
                                            mainList.map((book, index) => {
                                                return (
                                                    <div key={index} >
                                                        <BookCard book={book} onEdit={(book: Book) => this.setState({ bookToEdit: book, showForm: true })} />
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                            }
                            <Button
                                size={'large'}
                                color="secondary"
                                className={classes.addButton}
                                variant={'contained'}
                                onClick={e => this.setState({ showForm: true })}
                            >
                                Add New
                </Button>
                            <Dialog open={Boolean(this.state.selectedBook)} >
                                {selectedBook ? <BookDetails onClose={() => this.setState({ selectedBook: undefined })} book={selectedBook} /> : <div />}
                            </Dialog>
                        </div>
                        : null
                }
                { showForm ? <Form onClose={() => this.setState({ showForm: false, bookToEdit: undefined })} open={showForm} book={bookToEdit} /> : null}
            </>
        )
    }
}

const mapStateToProps = ({ Books: { mainList } }: ReduxStore): IStateProps => ({
    mainList
})

const mapDispatchToProps = (dispatch: TDispatch): IDispatchProps => ({
    getPageData: () => dispatch(OBook.getItemsList()),
    deleteBook: (id: string) => dispatch(OBook.deleteItem(id, {}, undefined, { deletedItemId: id })),
    togglePublish: (book) => dispatch(OBook.postActivity(OBook.Activities.TOGGLE_PUBLISH, {}, { id: book.id, publish: !book.isPublished }))
})

const STYLES = (theme: typeof MuiTheme) => createStyles({
    root: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: 25,
        height: '100%'
    },
    listContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        width: 950,
        paddingTop: 30
    },
    addButton: {
        position: 'fixed',
        right: '24px', top: 64 + 24
    }
})

export default withRouter(connect<IStateProps, IDispatchProps, OwnProps, ReduxStore>(mapStateToProps, mapDispatchToProps)(withStyles(STYLES)(Books)))